<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogAddClient"
    :before-close="doClose"
    width="70%"
    top="5vh"
  >
    <el-form
      :ref="refForm"
      :rules="rules"
      :model="clientform"
      :label-width="$t('language.name')=='中文'?'150px':'200px'"
    >
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item prop="agencyName" :label="$t('desc.dealername')">
            <el-input v-model="clientform.agencyName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item prop="agencyCode" :label="$t('title.dealercode')">
            <el-input v-model="clientform.agencyCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="brandCode" :label="$t('title.brand')">
            <el-select style="width: 100%" @change="changeBrand" v-model="clientform.brandCode" :placeholder="$t('desc.select')">
              <el-option
                :label="brandInfo.brandName"
                :value="brandInfo.brandCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item prop="customerCenter" :label="$t('title.customerCenter')">
            <template slot-scope="scope">
              <el-cascader
                v-model="clientform.regionList"
                :placeholder="$t('desc.select')"
                :options="optionscenter"
                :key="(!optionscenter||optionscenter.length==0)?0:1"
                @change="handleChange"
                style="width: 100%"
              ></el-cascader>
            </template>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item prop="companyType" :label="$t('title.companyType')">
            <el-select
              v-model="clientform.companyType"
              :placeholder="$t('desc.select')"
              style="width: 100%"
            >
              <!-- <el-option :value="$t('desc.straightPipe')" :label="$t('desc.straightPipe')"></el-option> -->
              <el-option :value="$t('desc.dealer')" :label="$t('desc.dealer')"></el-option>
              <el-option
                :value="$t('desc.serviceDistributor')"
                :label="$t('desc.serviceDistributor')"
              ></el-option>
              <el-option :value="$t('desc.middleman')" :label="$t('desc.middleman')"></el-option>
              <el-option :value="$t('desc.other')" :label="$t('desc.other')"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item prop="address" :label="$t('title.address')">
            <el-input v-model="clientform.address"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="success" @click="onSubBtn(refForm)">{{$t("button.confirm")}}</el-button>
        <el-button @click="doClose">{{$t("button.cancel")}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import {
  getBrandInfos,
  getCustomerRegionTree,
} from "../../../api/api"
export default {
  name: "index",
  props: {
    refForm: "",
    isAdd: true,
    subButtonAuth: false,
    clientform: {
      AgencyName: "",
      AgencyCode: "",
      CustomerCenter: "",
      RegionId: "",
      Address: "",
      CompanyType: "",
      ProvinceName: "",
      CityName: "",
      Status: "",
      regionList: {
        type: Array,
        default: function() {
          return [];
        }
      }
    },
    dialogAddClient: false,
    dialogAddMethod: false,
    title: "",
    
    isRequiredAgency: false
  },
  async mounted() {
    this.getBrandInfos();
    this.getCustomerRegionTree();
  },
  computed: {
    getCustInfo: function() {
      return this.clientform;
    }
  },
  watch: {
    dialogAddMethod: {
      async handler(newValue, oldValue) {
        if (newValue === true){
          await this.changeBrand();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      cascaderKey: 1,
      rules: {
        agencyName: [
          { required: true, message: this.$t("tips.needed"), trigger: "blur" }
        ],
        agencyCode: [
          { required: true, message: this.$t("tips.needed"), trigger: "blur" }
        ],
        regionList: [
          { required: true, message: this.$t("tips.needed"), trigger: "blur" }
        ],

        companyType: [
          {
            required: true,
            message: this.$t("tips.needed"),
            trigger: ["change", "blur"]
          }
        ],
        
      },
      brandInfo:{},
      centerList:[],
      optionscenter:[],
    };
  },
  methods: {
    async getBrandInfos(){
      let that=this;
      let res = await getBrandInfos();
      let brandCode=localStorage.getItem("user_brand")?localStorage.getItem("user_brand"):"IR";
      that.brandInfo = res.result.find(x=>x.brandCode==brandCode);
    },
    async getCustomerRegionTree() {
      let that = this;
      let res = await getCustomerRegionTree();
      that.centerList=res.result;
      let brandCode=localStorage.getItem("user_brand")?localStorage.getItem("user_brand"):"IR";
      this.optionscenter=this.centerList.filter(a=>a.brand==brandCode);
    },
    changeBrand(){
      // this.optionscenter=this.centerList.filter(a=>a.brand==this.clientform.brandCode);
    },
    onSubBtn(value) {
      this.$refs[value].validate(valid => {
        if (valid) {
          this.$emit("onSubBtn", true);
        } else {
          return false;
        }
      });
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.$refs[this.refForm].resetFields();
    },
    handleChange(value) {}
  }
};
</script>

<style scoped>
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #ebeef5;
  padding-left: 10px;
}

#formPer > .el-form-item {
  margin-bottom: 0px;
  border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
</style>
